import { IExpiringDocument } from '../types/profiles';

export type TExpiringDocumentWithId = { id: string } & IExpiringDocument;

// Drop docs that have been expired longer than this. They stay in the vault
// but disappear from the "things to action" summary views.
const HIDE_EXPIRED_AFTER_DAYS = 60;
const HIDE_EXPIRED_AFTER_MS = HIDE_EXPIRED_AFTER_DAYS * 24 * 60 * 60 * 1000;

// Sort by soonest expiry first; tiebreak on id so equal expiresAt values
// don't reshuffle on re-render. Filters out docs that have been expired
// longer than the grace period.
export const toSortedExpiringDocuments = (
  map?: Record<string, IExpiringDocument>
): TExpiringDocumentWithId[] => {
  const now = Date.now();
  return Object.entries(map ?? {})
    .map(([id, doc]) => ({ id, ...doc }))
    .filter((d) => {
      const ms = d.expiresAt?.toMillis?.();
      if (ms == null) return true;
      return now - ms <= HIDE_EXPIRED_AFTER_MS;
    })
    .sort((a, b) => {
      const aMs = a.expiresAt?.toMillis?.() ?? 0;
      const bMs = b.expiresAt?.toMillis?.() ?? 0;
      if (aMs !== bMs) return aMs - bMs;
      return a.id.localeCompare(b.id);
    });
};
